var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL05 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 334.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-1678.00, 0.00)",
    id: "L5_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915.65,52.52 C1911.18,50.74 1896.12,47.45 1888.08,46.50 C1879.41,45.49 1863.53,45.37 1855.59,46.28 C1847.93,47.18 1833.77,51.20 1826.93,53.98 C1820.85,56.48 1755.98,89.25 1741.89,96.23 C1730.55,101.66 1720.07,107.55 1714.09,112.17 C1708.13,116.81 1698.32,127.45 1694.78,133.56 C1691.25,139.74 1686.33,153.53 1684.94,161.14 C1684.17,165.45 1682.45,184.91 1681.97,192.89 C1681.62,200.87 1681.32,216.77 1681.69,224.15 C1682.15,231.47 1683.46,246.15 1684.30,253.50 C1685.77,264.67 1687.75,275.56 1690.12,283.20 C1692.50,290.78 1699.72,307.28 1703.67,314.20 C1705.85,317.99 1714.75,330.91 1720.27,338.19 C1725.17,344.31 1735.85,356.68 1741.64,362.93 C1748.94,370.48 1759.87,380.86 1765.96,385.90 C1772.05,390.91 1784.23,399.50 1790.33,403.08 C1797.56,407.20 1811.92,413.05 1819.68,415.06 C1827.44,417.03 1842.76,418.67 1850.75,418.37 C1858.51,418.06 1873.47,415.78 1880.71,413.80 C1887.73,411.86 1900.81,406.60 1908.21,402.27 C1914.66,398.47 1927.09,389.33 1933.08,383.99 C1938.83,378.83 1950.49,366.51 1955.67,360.23 C1960.85,353.93 1969.63,341.61 1974.44,333.88 C1977.83,328.34 1985.56,312.16 1988.60,304.52 C1991.64,296.88 1995.92,283.68 1998.86,272.90 C2000.85,264.94 2004.19,249.48 2005.53,241.98 C2006.66,234.64 2008.35,220.73 2008.53,210.69 C2008.66,202.06 2007.63,185.78 2006.47,178.07 C2005.30,170.44 2001.82,156.09 1999.54,149.43 C1996.80,141.54 1989.93,128.58 1985.35,122.06 C1976.67,109.80 1934.72,65.16 1934.53,64.96 C1929.75,59.99 1919.03,53.88 1915.65,52.52 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL05, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-05.94410c75.svg";
export { ForwardRef as ReactComponent };